import request from '@/util/http';

export default {
  list,         //公司列表
  auditCom,     //公司审核
  newList,      //新闻列表
  addNew,       //添加公告
  delNew,       //删除公告
  auditNew,     //审核公告
  companyadd,   //注册账号及公司创建接口
}
function companyadd(data) {
  return request({
    url: "company/api/companyadd",
    method: 'post',
    data
  })
}

function list(data) {
  return request({
    url: "sys/api/companylist",
    method: 'post',
    data
  })
}

function auditCom(data) {
  return request({
    url: "sys/api/companyaudit",
    method: 'post',
    data
  })
}

function newList(data) {
  return request({
    url: 'sys/api/noticelist',
    method: 'post',
    data
  })
}

function addNew(data) {
  return request({
    url: 'sys/api/addorupdatenotice',
    method: 'post',
    data
  })
}

function delNew(data) {
  return request({
    url: 'sys/api/deletenoticebyid',
    method: 'post',
    data
  })
}

function auditNew(data) {
  return request({
    url: 'sys/api/auditnotice',
    method: 'post',
    data
  })
}